export const CompletedJobs = {
    Title: 'Job History',
    Headers: {
        NoJobsFound: 'No Jobs Found'
    }

}
export const CompletedJobsItem = {
    Title: 'Completed job',
    ActiveTitle: 'Active job',
    Text: {
        JobLocation: 'Job Location',
        Price: 'Price: $',
        JobTime: 'Job Time'

    },
    Buttons: {
        Back: {
            label: 'Back'
        },
        Repost:{
            label: 'Repost'
        },
        Rate: {
            label: 'Rate'
        },
        Support:{
            label: 'Support'
        }
    }
}
export const CompletedJobItemDetailed = {
    Text: {
        Latest: 'latest',
        Cancelled: 'Cancelled'
    }
}



// WEBPACK FOOTER //
// ./src/localization/CompletedJobs.ts